import config from './config.json'
import http from './httpService'

export const getGoogle2af=()=>{
    return http.get(`${config.coinbaseapi}/settings/google-2fa`)
}

export const verifyGoogle2af = code =>{
    return http.post(`${config.coinbaseapi}/settings/google-2fa/verify`,code)
}